import React from 'react'
import SearchNav from '../../SearchNav/SearchNav'

const Models = () => {
  return (
    <div>
        {<SearchNav/>}
        <h1 className='p-3'>Models</h1>
    </div>
  )
}

export default Models